// extracted by mini-css-extract-plugin
export var equalColumn = "_dq-0";